import {
    Box,
    Card as MuiCard,
    CardContent,
    Typography,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    FormHelperText,
    Grid,
    TextField,
    Fab as MuiFab,
    withStyles,
    Button,
    Tooltip
} from '@material-ui/core'
import { useDispatch, useSelector } from "../../../redux/store";
import React, { useState, useEffect, useContext } from 'react'
import { spacing } from "@material-ui/system";
import styled from "styled-components/macro";
import {
    Add as AddIcon,
    Remove
} from "@material-ui/icons";
import GoogleMapReact from "google-map-react";
import { AppStateType } from "../../../redux/reducers";
import {Form, Formik, FormikValues, useFormik, useFormikContext} from "formik";
import MapPin from '../../../components/MapPin';
import countryRegionData from "country-region-data";
import { getAddressDataFromSearch, LocationAutocomplete } from '../../../components/LocationAutocomplete';
import * as Yup from "yup";
import { createProperty, updateProperty } from '../../../redux/actions/propertyActions';
import {
    correctionUnitName,
    decodePin,
    formDataAppendObject, getCurrentIsoLanguage, getDefaultLanguagesObject,
    isValidInt,
    preventNonDigitSymbolInput,
    trimNumberString
} from "../../../utils/functions";
import { geocodeByAddress } from 'react-places-autocomplete';
import { QuestionnaireContext } from '../../../components/contexts/QuestionnaireContext';
import { urls, useRouting } from '../../../routes';
import { fetchA11yStandard } from '../../../redux/actions/a11yStandardActions';
import { fetchPropertyCategories, fetchPropertySubCategories, fetchPropertyTopCategories } from '../../../services/propertyFormService';
import { useEffectAsync } from '../../../hooks/useEffectAsync';
import { SubCategory, SupportedStandards, Category } from '../../../models/utils';
import {fetchCompaniesInLive, fetchCompany, fetchCompanyOptions} from "../../../redux/actions/companyActions";
import { useTranslation } from "react-i18next";
import i18n from "../../../translations/i18n";
import {Alert} from "@mui/material";
import {CloudUpload} from "@mui/icons-material";
import {makeStyles} from "@material-ui/core/styles";
import Loading from "../../../components/Loading";
import {getCompanies} from "../../../selectors";
import AccordionMultiLanguageInputs from "../../../components/AccordionMultiLanguageInputs";
const Fab = styled(MuiFab)(spacing);

export const CustomInputContainer = styled.input`
    border: 1px solid rgba(255, 255, 255, 0.5);
    border-radius: 6px;
    color: white;
    height: 32px;
    min-width: 32px;
    background: transparent;
    text-align: center;
    max-width: 60px;
    ::-webkit-outer-spin-button,
    ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
`

const NoHaveImage = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 200px;
    width: 200px;
    border-radius: 6px;
    background: #677d8bb8;
    color: #233044;
    font-weight: 600;
`

const MapAlert = styled(Alert)`
    margin-top: 15px;
`

export const GradientButton = withStyles({
    root: {
        color: 'black',
        backgroundImage: 'linear-gradient(90deg, #84FAB0 0%, #8FEAFE 100%);',
        borderRadius: '6px',
    },
    disabled: {
        background: '#434C58',
        border: '1px solid #434C58'
    }
})(Button);

export const GrayButton = withStyles({
    root: {
        color: '#FFFFFF',
        background: 'rgba(120, 144, 156, 0.1)',
        borderRadius: '6px'
    },
    disabled: {
        background: '#434C58',
        border: '1px solid #434C58'
    }
})(Button);

const StyledButton = withStyles({
    root: {
        color: 'black',
        background: 'linear-gradient(90deg, #84FAB0 0%, #8FEAFE 100%)',
        border: '1px solid #00F5C3',
        height: '32px',
        width: '35px',
    },
})(Fab);
const GoogleMapReactWrapper = styled.div`
  height: 300px;
  width: 100%;
  position: relative;
`;
const Card = styled(MuiCard)(spacing);



const renderCategoryOptions =  (categories: Category[] |  undefined, token: any) => {
    if(categories){
        return categories.map((item, index) => {
            return (<MenuItem value={item.key} key={index}>{item.title}</MenuItem>)
        })

    }
}

const renderPropertylTypeOptions = (subCategory: SubCategory[] | undefined) => {
    if(subCategory){
        return subCategory.map((item, index) => {
            return (<MenuItem value={item.key} key={index}>{item.title}</MenuItem>)
        })

    }
}

const getMapOptions = (maps: GoogleMapReact.Maps) => {
    return {
        fullscreenControl: true,
        mapTypeControl: true,
        mapTypeId: maps.MapTypeId.ROADMAP,
        scaleControl: true,
        scrollwheel: false,
        streetViewControl: true,
    };
}

function normalizeString(value: string) {
    return value.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
}

const AddSubstractInput = (props: {
    value: number;
    field: string;
    onChange: React.ChangeEventHandler<HTMLInputElement> | undefined
    setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void
    isOnlyDigits?: boolean;
    maxValue?: number;
    hideIncreaseQuantityButton?: boolean;
    hideDecreaseQuantityButton?: boolean;
    error?: boolean
}) => {
    const { value, isOnlyDigits, field, onChange, setFieldValue, maxValue, hideDecreaseQuantityButton,
        hideIncreaseQuantityButton } = props;
    return <React.Fragment>
        {!hideDecreaseQuantityButton ?
            <StyledButton mx={2}
                aria-label="Minus"
                name={'minus'}
                onClick={() => {
                    if (value > 0) {
                        setFieldValue(field, value - 1)
                    }
                }}
            >
                <Remove />
            </StyledButton>
            : null}
        <CustomInputContainer
            value={value}
            type="number"
            name={field}
            style={{
                marginRight: hideIncreaseQuantityButton ? '51px' : '0px',
                border: `1px solid ${props.error ? '#f44336' : 'rgba(255,255,255,0.5)'}`
            }}
            onChange={(event) => {
                if (onChange) {
                    trimNumberString(event);
                    (isValidInt(0, maxValue || 1000)(event) || !isOnlyDigits) && onChange(event)
                }
            }}
            onKeyDown={preventNonDigitSymbolInput}
        />
        {!hideIncreaseQuantityButton ?
            <StyledButton mx={2}
                aria-label="Plus"
                name={'plus'}
                onClick={() => setFieldValue(field, value + 1)}
            >
                <AddIcon />
            </StyledButton> : null}
    </React.Fragment>
}
const GetGeolocation = <T extends object, K extends keyof T>(props: {
    setValues: (values: T) => void,
    values: T,
    setFieldValue: (key: K, value: any) => void
    isValidAddress: (address_componentents: google.maps.GeocoderAddressComponent[]) => void
}) => {
    const { setFieldValue } = props;
    const property: any = useSelector((state: AppStateType) => state.propertyReducer.property)
    const [geocoder] = useState(new google.maps.Geocoder());
    function geoError() {
        console.log("Geocoder failed.")
    }
    const succesHandler = async (position: GeolocationPosition) => {
        await geocoder.geocode({
            location: {
                lat: position.coords.latitude,
                lng: position.coords.longitude
            }
        }, (results, status) => {
            if (status === google.maps.GeocoderStatus.OK && results) {
                const bestAproximation = results[0];
                const address = bestAproximation.formatted_address;

                const address_components = getAddressDataFromSearch(bestAproximation);
                props.isValidAddress(bestAproximation.address_components);
                // the reason why i opted for this is because values will not change while the pop-up is ... up
                //this is not a great solution , but it gets the job done
                Object.keys(address_components).forEach(key => setFieldValue(key as any, address_components[key]))
                setFieldValue("lat" as any, position.coords.latitude);
                setFieldValue("lng" as any, position.coords.longitude);
                setFieldValue("full_address" as any, address);
            }
        });
    }
    function getLocation() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(succesHandler, geoError);
        } else {
        }
    }
    useEffect(() => {
        if (!property) {
            getLocation();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [property])
    return <React.Fragment />
}

const ValidFormMiddleware = (p: {
    onValidChange: (v: boolean) => void
    handleSubmitFn: (fn: (values: any) => void) => void
}) => {
    let { onValidChange } = p;
    const { isValid, submitForm } = useFormikContext();
    useEffect(() => {

        p.handleSubmitFn(submitForm)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [submitForm]);
    useEffect(() => {
        onValidChange(isValid);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isValid]);
    return null;
}

const useStyles = makeStyles({
    formControl: {
        marginBottom: 8,
    },
})

export default function PropertyForm(props: {
    addMode?: boolean;
    onValidChange?: (v: boolean) => void
    handleSubmitFn?: (fn: (values: any) => void) => void
    nextStepIsPressed?: boolean;
    onExit?: any
}) {
    const { routeTo } = useRouting();
    const { addMode, onValidChange, handleSubmitFn, onExit, nextStepIsPressed } = props;
    const user: any = useSelector((state: AppStateType) => state.authReducer.user)
    const userProfile: any = useSelector((state: AppStateType) => state.userReducer.user);
    const property: any = useSelector((state: AppStateType) => state.propertyReducer.property)
    const standard = useSelector((state: AppStateType) => state.a11yStandardReducer.a11yStandard);
    const company: any = useSelector((state: AppStateType) => state.companyReducer.company);
    const companyOptions: any = useSelector((state: AppStateType) => state.companyReducer.options);
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [validAddress, setValidAddress] = useState(true)
    const [propertyCategory, setPropertyCategory] = useState<Category[]>();
    const [addressComponents, setAddressComponents] = useState<google.maps.GeocoderAddressComponent[] | never[] | never>([])
    const [requiredLevelSize, setRequiredLevelSize] = useState({ propertyFloors: true, propertyRooms: true })
    const [selectedStandard, setSelectedStandard] = useState<string>();
    const [selectedCategory, setSelectedCategory ] = useState<string>();
    const [subCategories, setSubCategories] = useState<SubCategory[]>();
    const [supportedStandards, setSupportedStandards] = useState<SupportedStandards[]>([]);
    const [load, setLoad] = useState<Boolean>(true);
    const [lastIndex, setLastIndex] = useState<number>(0);
    const [showAlert, setShowAlert] = useState<boolean>(false)
    const classes = useStyles()
    const [isValidForm, setIsValidForm] = useState(true)
    const [loading, setLoading] = useState(false)
    const companies = useSelector<any>(getCompanies)
    const currentLanguage = getCurrentIsoLanguage(company ? company?.supported_languages : [])

    useEffect(() => {
        if (userProfile && userProfile.company) {
            if (userProfile.is_staff) {
                dispatch(fetchCompaniesInLive(user!.token, false))
            }
            dispatch(fetchCompanyOptions(userProfile.company, user!.token))
        }

        if (lastIndex <= 0) {
          setLastIndex(lastIndex + 1);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [userProfile, lastIndex]);

    useEffect(() => {
        if (property) {
            dispatch(fetchCompany(property.company, user!.token));
        }
    }, [property]);

    useEffect(() => {
        if (company) {
            dispatch(fetchCompanyOptions(company.id, user!.token))
        }

        if (lastIndex <= 0) {
            setLastIndex(lastIndex + 1);
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
}, [company, lastIndex]);

    const {
        editState,
        // navToEdit,
    } = useContext(QuestionnaireContext);

    // useEffect(() => {
    //     if (userProfile && userProfile.company) {
    //       dispatch(fetchCompany(userProfile.company, user!.token));
    //     }
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    //   }, [userProfile]);

    const renderStandardTypeOptions = (company: any, supportedStandardsFriendlyName: SupportedStandards[]) => {
        if(supportedStandardsFriendlyName.length === 0){
            setLoad(true);
            return;
        }
        if(company.supported_a11y_standards){
            return company.supported_a11y_standards.map((item: any, index: any) => {
                return supportedStandardsFriendlyName.map((standard)=> {
                    if(standard.value === item){
                        return (<MenuItem value={item} key={index}>{standard.display_name}</MenuItem>)
                    }
                })

            })
        }
    }

    const validationSchema = Yup.object().shape({
        category: Yup.string().required(t("generalWords_Required")),
        topCategory: Yup.string().required(t("generalWords_Required")),
        standardType: Yup.string().required(t("generalWords_Required")),
        propertyType: Yup.string().required(t("generalWords_Required")),
        // propertyName: Yup.object({
        //     en: Yup.string().required(t("generalWords_Required"))
        // }),
        propertyArea: Yup.number().required(t("generalWords_Required")),
        propertyFloors: Yup.number().required(t("generalWords_Required")),
        propertyRooms: Yup.number().required(t("generalWords_Required")),
        full_address: Yup.string().required(t("generalWords_Required")),
    })

    const [initialValues, setInitialValues] = useState<any>({
        propertyName: { en: '' },
        country_code: "",
        city: "",
        region_code: "",
        postcode: "",
        propertyArea: '',
        category: '',
        propertyFloors: 0,
        lat: 59.3293,
        lng: 18.0686,
        propertyRooms: 0,
        address_line_1: property ? property.address_line_1 : "",
        full_address: property?.full_address !== '' ? property?.full_address : property?.address_line_1,
        propertyAllergyRooms: 0,
        propertyDisabledRooms: 0,
        propertyType: '',
        standardType: '',
        topCategory: '',
        general_image: '',
        new_general_image: '',
        general_image_description: '',
        company: '',
    })
    useEffect(() => {
        if (property) {
            const full_address = property?.address?.full_address !== '' ?
                property?.address?.full_address : property?.address?.address_line_1;
            geocodeByAddress(full_address).then((results) => {
                setAddressComponents(results[0].address_components)
            });

            const {
                additional_information: {
                    property_rooms,
                    allergy_rooms,
                    disabled_rooms,
                    link
                }
            } = property

            setInitialValues({
                ...initialValues,
                propertyName: property.name,
                propertyArea: property.amount_of_square_meters,
                propertyFloors: property.amount_of_floor_levels,
                propertyRooms: property_rooms ? property_rooms : 0,
                propertyAllergyRooms: allergy_rooms ? allergy_rooms : 0,
                propertyDisabledRooms: disabled_rooms ? disabled_rooms : 0,
                link: link ? link : '',
                propertyType: property.sub_category,
                standardType: property.a11y_standard,
                topCategory: property.top_category,
                lat: property.point.coordinates[1] ?? 59.3293,
                lng: property.point.coordinates[0] ?? 18.0686,
                address_line_1: property.address ? property.address.address_line_1 : '',
                full_address: full_address ? full_address : '',
                country_code: property.address ? property.address.country : '',
                postcode: property.address ? property.address.postcode : '',
                city: property.address ? property.address.city : '',
                region_code: property.address ? property.address.region_code : '',
                category: property.category,
                general_image: property.general_image,
                general_image_description: property.general_image_description,
                company: property.company,
            })
        } else {
            setInitialValues({
                ...initialValues,
                propertyName: getDefaultLanguagesObject(company ? company?.supported_languages : [])
            })
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [property, company])

    const handlerCategories = async () => {
        if (!selectedStandard) {
            return;
        }
        const categories = await fetchPropertyCategories(selectedStandard, user!.token);
        setPropertyCategory(categories.results);
    }

    const handlerSubCategories = async () => {
        if (!selectedCategory || !selectedStandard) {
            return;
        }

        const subCategories = await fetchPropertySubCategories(selectedStandard, selectedCategory, user!.token);
        setSubCategories(subCategories.results);
    }

    useEffect(() => {
        handlerCategories()
        handlerSubCategories()
    }, [i18n.language])


    useEffect(() => {
        if (load && companyOptions) {
            const companyData = companyOptions.actions;
            const companySupportedStandards =
            companyData.PUT.supported_a11y_standards.child.choices;
            setSupportedStandards(companySupportedStandards);
            setLoad(false);
        }
    }, [company, load, companyOptions]);

    useEffect(() => {
        handlerCategories()
      }, [selectedStandard])

    useEffect(() => {
        handlerSubCategories()
      }, [selectedCategory]);

    useEffect(() => {
        if (showAlert) {
            setTimeout(() => {
                setShowAlert(false)
            }, 3500)
        }
    }, [showAlert])


    async function getTopCategory(value: string, token: any, values: any, setValues: any){
        const topCategory = (await fetchPropertyTopCategories(value, token));
        const parsedTopCategory = topCategory.results[0].key;
        setValues({ ...values, topCategory: parsedTopCategory, standardType: value, category: initialValues.category, propertyType: initialValues.propertyType })
    }

    const onSubmit = async (values: typeof initialValues) => {
        if (!isValidForm) {
            return
        }
        const point = {
            type: "Point",
            coordinates: [values.lng, values.lat],
        }
        const country = countryRegionData.find(el => el.countryShortCode === values.country_code);
        if (!country) {
            console.log("region not found");
            return;
        }
        const region = country.regions.find(el => {
            const normalizedString = normalizeString(`${el.name}|${el.shortCode}`);
            return normalizedString.includes(normalizeString(values.region_code));
        })

        const address = {
            country: values.country_code,
            region_code: region ? region.shortCode : values.region_code,
            city: values.city,
            address_line_1: values.address_line_1 ? values.address_line_1 : values.full_address,
            full_address: values.full_address
        }
        const additional_information = {
            allergy_rooms: values?.propertyAllergyRooms ? values.propertyAllergyRooms : 0,
            disabled_rooms: values?.propertyDisabledRooms ? values.propertyDisabledRooms : 0,
            property_rooms: values?.propertyRooms ? values.propertyRooms : 0,
            link: values?.link ? values.link : ''
        }

        const getCompany = () => {
            let company = ''
            if (!property) {
                if (userProfile?.is_staff) {
                    company = values.company ? values.company : userProfile.company
                } else {
                    company = userProfile.company
                }
            } else {
                company = values.company
            }
            return company
        }

        const data = {
            address: address,
            name: correctionUnitName(values.propertyName),
            company: getCompany(),
            additional_information: additional_information,
            point: point,
            category: values ? values.category : '',
            sub_category: values ? values.propertyType : '',
            top_category: values ? values.topCategory : '',
            a11y_standard: values ? values.standardType : '',
            amount_of_floor_levels: values ? +values.propertyFloors : '',
            amount_of_square_meters: values ? +values.propertyArea : '',
            published: property ? property.published : false,
            general_image_description: values ? values.general_image_description : ''
        }

        const formData = new FormData()
        if (values.new_general_image) {
            formData.append('general_image', values.new_general_image)
        }

        setLoading(true)
        await dispatch(async (dp: any) => {
            if (property) {
                await updateProperty(data, user.token, property.id)(dp);
                if (formData.has('general_image')) {
                    await updateProperty(formData, user.token, property.id)(dp);
                }
                } else {
                await createProperty(data, user.token)(dp).then((response) => {
                    if (response.data && response.data.id) {
                        if (formData.has('general_image')) {
                            updateProperty(formData, user.token, response.data.id)(dp);
                        }
                    }
                });
            }
            await fetchA11yStandard(user.token)(dp);
            if (addMode) {
                routeTo(urls.standards);
            }
            setLoading(false)
        })
    }
    const isValidAddress = (address_components: google.maps.GeocoderAddressComponent[]) => {
        if (address_components) {
            // const result = address_components.some((e: any) => e.types.includes('route'))
            //     && address_components.some((e: any) => e.types.includes('street_number'))
            setAddressComponents(address_components)
            setValidAddress(true)
        }
    }

    const validationFields = (values: any): boolean => {
        if (!values) return false

        if (addressComponents.length > 0) {
            isValidAddress(addressComponents)
        }

        let propertyRooms = true
        if (values.standardType === 'hotel') {
            propertyRooms = values.propertyRooms !== 0
        }

        return validAddress && values.city && values.country_code &&
               values.propertyType && values.standardType && values.topCategory &&
               values.category && !!values.propertyName && values.propertyFloors !== 0 && propertyRooms
    }

    const formikValidate = (values: FormikValues) => {
        if (addressComponents.length > 0) {
            isValidAddress(addressComponents)
        } else {
            setValidAddress(false)
        }

        if (!validationFields(values) && onValidChange) {
            onValidChange(false)
        }

        let levelSize = { propertyFloors: true, propertyRooms: true }

        if (values.propertyFloors === 0) {
            levelSize = { ...levelSize, propertyFloors: false }
        }

        if (values.standardType === 'hotel' && values.propertyRooms === 0) {
            levelSize = { ...levelSize, propertyRooms: false }
        }
        setRequiredLevelSize(levelSize)
    }

    const getMainImage = (values: any) => {
        const data = {
            src: '',
            state: t('current_image')
        }
        if (values.general_image) {
            data.src = values.general_image
        }
        if (values.new_general_image) {
            data.src = URL.createObjectURL(values.new_general_image)
            data.state = 'New image'
        }

        if (data.src) {
            return (
                <div>
                    <span>{data.state}</span>
                    <img height={200} width={200} src={data.src} alt=''/>
                </div>
            )
        }

        if (values.general_image) {
          return (
            <img
              src={values.general_image}
              height={200}
              width={200}
            />
          )
        }
        return (
          <NoHaveImage>
              {t('no_picture')}
          </NoHaveImage>
        )
    }

    const handleChangeCompany = (id: string) => {
        dispatch(fetchCompany(id, user!.token));
    }

    return (
        <>
            <Formik
                initialValues={initialValues}
                enableReinitialize
                validationSchema={validationSchema}
                onSubmit={onSubmit}
                validate={formikValidate}
            >
                {({
                    values,
                    handleBlur,
                    handleChange,
                    setFieldValue,
                    isValid,
                    setValues,
                    errors,
                }) => {

                    const handlePropertyName = (text: string, language: string) => {
                        setFieldValue(`propertyName[${language}]`, text)
                    };

                    const trackTotalRoomsCount = (totalRooms: number, disabledRooms: number,
                        allergyRooms: number): void => {
                        if (totalRooms < values.propertyDisabledRooms) {
                            disabledRooms = totalRooms
                        }
                        if (totalRooms < values.propertyAllergyRooms) {
                            allergyRooms = totalRooms
                        }
                        setValues({
                            ...values,
                            propertyDisabledRooms: disabledRooms,
                            propertyAllergyRooms: allergyRooms
                        })
                    }
                    const onDragEnd = async (val: any) => {
                        try {
                            const center = {
                                lat: val.center.lat(),
                                lng: val.center.lng()
                            }
                            const data = await decodePin(center);
                            setAddressComponents(data!.address_components);
                            // isValidAddress(data!.address_components);
                            setValues({
                                ...values,
                                ...(getAddressDataFromSearch(data)),
                                lat: center.lat,
                                lng: center.lng
                            })
                        } catch (e) {
                            setShowAlert(true)
                        }
                    }
                    setIsValidForm(isValid && validationFields(values) && Object.keys(errors).length === 0)

                    const getPropertyNameError = () => {
                        if (nextStepIsPressed || initialValues.propertyName[currentLanguage] !== values.propertyName[currentLanguage]) {
                            return values.propertyName && values.propertyName[currentLanguage] === ''
                        }
                        return false
                    }

                    return <Form>
                        {validationFields(values) && onValidChange && handleSubmitFn &&
                            <ValidFormMiddleware
                              onValidChange={onValidChange}
                              handleSubmitFn={handleSubmitFn}
                            />
                        }
                        <GetGeolocation
                            values={values}
                            setValues={setValues}
                            isValidAddress={isValidAddress}
                            setFieldValue={setFieldValue}
                        />
                        <Box pt={4}>
                            <Card>
                                <CardContent>
                                    <Typography variant="h6" style={{ marginBottom: "20px" }} >
                                        {t("propertyForm_propertyInformation")}
                                    </Typography>
                                    <Grid container spacing={4}>
                                        <Grid item xs={12} sm={6}>
                                            {userProfile?.is_staff ? (
                                              <FormControl
                                                fullWidth
                                                className={classes.formControl}
                                              >
                                                  <InputLabel id="company-label">
                                                      Company
                                                  </InputLabel>
                                                  <Select
                                                    label='Company'
                                                    id='company'
                                                    labelId="company-label"
                                                    value={values.company}
                                                    name="company"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                  >
                                                      {companies?.length > 0 && companies.map((companyItem: any, index: number) => (
                                                        <MenuItem value={companyItem.id} key={index} onClick={() => handleChangeCompany(companyItem.id)}>{companyItem.name}</MenuItem>
                                                      ))}
                                                  </Select>
                                              </FormControl>
                                            ) : null}
                                            <FormControl
                                              fullWidth
                                              disabled={!!initialValues.standardType}
                                              error={(initialValues.standardType !== values.standardType) || nextStepIsPressed ?
                                              Boolean(errors.standardType) : false}
                                              className={classes.formControl}
                                            >
                                                <InputLabel id="standard-type-label">
                                                    {t("propertyForm_standardType")}
                                                </InputLabel>
                                                <Select
                                                    label={t("propertyForm_standardType")}
                                                    id={'standard-type'}
                                                    labelId="standard-type-label"
                                                    value={values.standardType}
                                                    name="standardType"
                                                    onChange={(e: any) => {
                                                        if (e.target.value) {
                                                            getTopCategory(
                                                              e.target.value,
                                                              user!.token,
                                                              values,
                                                              setValues
                                                            );
                                                        }
                                                    }}
                                                    onBlur={handleBlur}
                                                >
                                                    {(supportedStandards && company) ? renderStandardTypeOptions(company, supportedStandards) : null}
                                                </Select>
                                                <FormHelperText>{
                                                    `${t("generalWords_Required")} (${t("propertyForm_fieldCannotBeChanged")})`
                                                }</FormHelperText>
                                            </FormControl>
                                            <FormControl
                                              fullWidth
                                              error={(initialValues.category !== values.category) || nextStepIsPressed  ? Boolean(errors.category) : false}
                                              className={classes.formControl}
                                            >
                                                <InputLabel>
                                                    {t("propertyForm_propertyCategory")}
                                                </InputLabel>
                                                <Select
                                                  value={values.category}
                                                  name="category"
                                                  onChange={(e: any) => {
                                                      if (e.target.value) {
                                                          setValues({
                                                              ...values,
                                                              category: e.target.value,
                                                              propertyType: initialValues.propertyType
                                                          })
                                                      }
                                                  }}
                                                  onBlur={handleBlur}
                                                >
                                                    {setSelectedStandard(values.standardType)}
                                                    {renderCategoryOptions(propertyCategory, user.token)}
                                                </Select>
                                                <FormHelperText>{t("generalWords_Required")}</FormHelperText>
                                            </FormControl>
                                            <FormControl
                                              fullWidth
                                              error={(initialValues.propertyType !== values.propertyType) || nextStepIsPressed ?
                                                Boolean(errors.propertyType) : false
                                              }
                                              className={classes.formControl}
                                            >
                                                <InputLabel id="demo-simple-select-placeholder-label-label">
                                                    {t("propertyForm_typeOfProperty")}
                                                </InputLabel>
                                                <Select
                                                  value={values.propertyType}
                                                  name="propertyType"
                                                  onChange={handleChange}
                                                  onBlur={handleBlur}
                                                >
                                                    {setSelectedCategory(values.category)}
                                                    {renderPropertylTypeOptions(subCategories)}
                                                </Select>
                                                <FormHelperText>{t("generalWords_Required")}</FormHelperText>
                                            </FormControl>
                                            <Box mb={4}>
                                                <AccordionMultiLanguageInputs
                                                  label={"propertyForm_propertyName"}
                                                  value={values.propertyName}
                                                  onChange={handlePropertyName}
                                                  variant={'standard'}
                                                  helperText={t("generalWords_Required")}
                                                  error={getPropertyNameError()}
                                                />
                                            </Box>
                                            <TextField
                                              fullWidth
                                              label={t("propertyForm_propertyArea")}
                                              type="number"
                                              value={values.propertyArea}
                                              name="propertyArea"
                                              onChange={(event) => {
                                                  trimNumberString(event);
                                                  isValidInt(0, 1000000)(event) && handleChange(event)
                                              }}
                                              onKeyDown={preventNonDigitSymbolInput}
                                              onBlur={handleBlur}
                                              helperText={t("generalWords_Required")}
                                              error={(initialValues.propertyArea !== values.propertyArea) || nextStepIsPressed  ?
                                                Boolean(errors.propertyArea) : false
                                              }
                                              InputProps={{
                                                  inputProps: {
                                                      max: 1000000, step: 1,
                                                  }
                                              }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <Box display='flex' justifyContent='center' alignItems='center' flexDirection='column'>
                                                {getMainImage(values)}
                                                <Box mt={5}>
                                                    <input
                                                      accept="image/*"
                                                      style={{ display: 'none' }}
                                                      id="general-image"
                                                      multiple
                                                      type="file"
                                                      onChange={(e) => {
                                                          const {files} = e.target
                                                          if (files && files.length > 0) {
                                                              setFieldValue("new_general_image", files[0]);
                                                          }
                                                      }}
                                                    />
                                                    <label htmlFor="general-image">
                                                        <Button
                                                          variant="outlined"
                                                          component="span"
                                                          style={{minWidth: 200, display: 'flex', justifyContent: 'center', alignItems: 'center'}}
                                                        >
                                                            <Box mr={1}><CloudUpload/></Box>
                                                            {t('upload_new_picture')}
                                                        </Button>
                                                    </label>
                                                </Box>
                                                <Box mt={2} width={'100%'}>
                                                    <TextField
                                                      fullWidth
                                                      label={t('image_description')}
                                                      onChange={handleChange}
                                                      value={values.general_image_description}
                                                      name="general_image_description"
                                                    />
                                                </Box>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    <Typography variant="h6" style={{ marginTop: "30px", marginBottom: "20px" }} gutterBottom>
                                        {t("propertyForm_enterPropertyAddress")}
                                    </Typography>
                                    <Box
                                    >
                                        <Grid container >
                                            <Grid item xs={12} sm={6}>
                                                <Box pr={4}>
                                                    <Typography variant='subtitle1' gutterBottom>
                                                        {t("propertyForm_addressLocation")}
                                                    </Typography>
                                                    <LocationAutocomplete
                                                        fullAddressError={(initialValues.full_address !== values.full_address) || !values.full_address ?
                                                            errors.full_address : false
                                                        }
                                                        validAddress={validAddress}
                                                        value={values?.full_address}
                                                        isValidAddress={isValidAddress}
                                                        onConfirmLocation={obj => {
                                                            const { addressData, latLng } = obj;
                                                            setValues({
                                                                ...values,
                                                                ...addressData,
                                                                lat: latLng.lat,
                                                                lng: latLng.lng
                                                            })
                                                        }}
                                                    />
                                                    <FormHelperText>{
                                                        `${t("generalWords_Required")} (${t("propertyForm_mapNote")})`
                                                    }</FormHelperText>
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} sm={6} style={{ marginTop: "25px" }}>
                                                <GoogleMapReactWrapper>
                                                    <div style={{
                                                        position: "absolute",
                                                        height: "100px",
                                                        width: "100px",
                                                        zIndex: 1,
                                                        left: "50%",
                                                        top: "50%",
                                                        transform: "translate(-50%,-50%)",
                                                    }}>
                                                        <MapPin lat={values.lat} lng={values.lng} />
                                                    </div>
                                                    <GoogleMapReact
                                                        options={getMapOptions}
                                                        bootstrapURLKeys={{
                                                            key: "AIzaSyD5R0bYPps6EYg2B4d1VFoZJ3lJrVlZX-s",
                                                        }}
                                                        onDragEnd={onDragEnd}
                                                        center={{
                                                            lat: values.lat,
                                                            lng: values.lng
                                                        }}
                                                        defaultZoom={14}
                                                    >
                                                    </GoogleMapReact>

                                                </GoogleMapReactWrapper>

                                                {showAlert ? (
                                                  <MapAlert severity="warning">
                                                      Please move slower
                                                  </MapAlert>
                                                ) : null}
                                            </Grid>
                                        </Grid>
                                    </Box>

                                </CardContent>
                            </Card>
                            <Card mt={4}>
                                <CardContent>
                                    <Typography variant="h6" style={{ marginBottom: "25px" }}>
                                        {t("propertyForm_keyPropertyData")}
                                    </Typography>
                                    <Box>
                                        <Grid container alignItems="center">
                                            <Grid item xs={6} sm={8}>
                                                <Typography variant="subtitle2" gutterBottom>
                                                    {t("propertyForm_floorsQuestion")}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={6} sm={4}>
                                                <Box display="flex" alignItems="center" justifyContent="flex-end">
                                                    <AddSubstractInput
                                                        error={(initialValues.propertyFloors !== values.propertyFloors) || nextStepIsPressed || property && values.propertyFloors === 0 ?
                                                            !requiredLevelSize.propertyFloors : false
                                                        }
                                                        value={values.propertyFloors}
                                                        field="propertyFloors"
                                                        hideDecreaseQuantityButton={values.propertyFloors === 0}
                                                        onChange={handleChange}
                                                        setFieldValue={setFieldValue}
                                                        isOnlyDigits={true}
                                                        maxValue={1000}
                                                    />
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                    {values.standardType === 'hotel' ? (
                                      <Box mt={4}>
                                          <Grid container alignItems="center">
                                              <Grid item xs={6} sm={8}>
                                                  <Typography variant="subtitle2" gutterBottom>
                                                      {t("propertyForm_roomsQuestion")}
                                                  </Typography>
                                              </Grid>
                                              <Grid item xs={6} sm={4}>
                                                  <Box display="flex" alignItems="center" justifyContent="flex-end">
                                                      <AddSubstractInput
                                                        error={(initialValues.propertyRooms !== values.propertyRooms) || nextStepIsPressed || property && values.propertyRooms === 0 ?
                                                          !requiredLevelSize.propertyRooms : false
                                                        }
                                                        value={values.propertyRooms}
                                                        field="propertyRooms"
                                                        hideDecreaseQuantityButton={values.propertyRooms === 0}
                                                        onChange={(event) => {
                                                            trackTotalRoomsCount(
                                                              parseInt(event.target.value),
                                                              values.propertyDisabledRooms, values.propertyAllergyRooms
                                                            )
                                                            handleChange(event)
                                                        }}
                                                        setFieldValue={(field, value, shouldValidate) => {
                                                            trackTotalRoomsCount(
                                                              value,
                                                              values.propertyDisabledRooms,
                                                              values.propertyAllergyRooms
                                                            )
                                                            setFieldValue(field, value, shouldValidate)
                                                        }}
                                                        isOnlyDigits={true}
                                                        maxValue={10000}
                                                      />
                                                  </Box>
                                              </Grid>
                                          </Grid>
                                      </Box>
                                    ) : null }
                                    {values.propertyRooms > 0 && values.standardType === 'hotel' ?
                                        <Box mt={4}>
                                            <Grid container alignItems="center">
                                                <Grid item xs={6} sm={8}>
                                                    <Typography variant="subtitle2" gutterBottom>
                                                        {t("propertyForm_disabledRoomsQuestion")}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={6} sm={4}>
                                                    <Box display="flex" alignItems="center" justifyContent="flex-end">
                                                        <AddSubstractInput
                                                            value={values.propertyDisabledRooms}
                                                            hideDecreaseQuantityButton={values.propertyDisabledRooms === 0}
                                                            hideIncreaseQuantityButton={values.propertyDisabledRooms >= values.propertyRooms}
                                                            field="propertyDisabledRooms"
                                                            onChange={handleChange}
                                                            setFieldValue={setFieldValue}
                                                            isOnlyDigits={true}
                                                            maxValue={values.propertyRooms}
                                                        />
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        </Box> : null}
                                    {values.propertyRooms > 0 && values.standardType === 'hotel' ?
                                        <Box mt={4}>
                                            <Grid container alignItems="center">
                                                <Grid item xs={6} sm={8}>
                                                    <Typography variant="subtitle2" gutterBottom>
                                                        {t("propertyForm_alergyRoomsQuestion")}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={6} sm={4}>
                                                    <Box display="flex" alignItems="center" justifyContent="flex-end">
                                                        <AddSubstractInput
                                                            value={values.propertyAllergyRooms}
                                                            hideDecreaseQuantityButton={values.propertyAllergyRooms === 0}
                                                            hideIncreaseQuantityButton={values.propertyAllergyRooms >= values.propertyRooms}
                                                            field="propertyAllergyRooms"
                                                            onChange={handleChange}
                                                            setFieldValue={setFieldValue}
                                                            isOnlyDigits={true}
                                                            maxValue={values.propertyRooms}
                                                        />
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        </Box> : null}
                                    {values.standardType === 'hotel' ? (
                                      <Box mt={4}>
                                          <Grid container alignItems="center">
                                              <Grid item xs={6} sm={8}>
                                                  <Typography variant="subtitle2" gutterBottom>
                                                      Link for button 'Book now'
                                                  </Typography>
                                              </Grid>
                                              <Grid item xs={6} sm={4}>
                                                  <TextField
                                                    fullWidth
                                                    label={'Link'}
                                                    type="string"
                                                    value={values.link}
                                                    name="link"
                                                    onChange={handleChange}
                                                    InputProps={{
                                                        inputProps: {
                                                            max: 1000000, step: 1,
                                                        }
                                                    }}
                                                  />
                                              </Grid>
                                          </Grid>
                                      </Box>
                                    ) : null}
                                    <Box pt={2} bgcolor={"#233044"}>
                                        <FormHelperText>{t("generalWords_Required")}</FormHelperText>
                                        {addMode && (
                                            <Box p={3} bgcolor={"#233044"} display="flex" justifyContent="center" style={{ marginTop: "10px"}}>
                                                <Tooltip
                                                    arrow={true}
                                                    placement="top"
                                                    title={
                                                        !isValidForm ?
                                                            <span style={{fontSize: 12}}>{t("propertyForm_nextStep_tooltip")}</span> :
                                                            ''
                                                      }
                                                >
                                                    <GradientButton
                                                      type="submit"
                                                    >
                                                        {t("propertyForm_save")}
                                                    </GradientButton>
                                                </Tooltip>
                                            </Box>
                                        )}
                                    </Box>
                                </CardContent>
                            </Card>
                        </Box>
                    </Form>
                }}
            </Formik>
            <Loading open={loading}/>
        </>
    )
}
